import React, { useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Box,
  Typography,
} from "@mui/material";
import LoanCard from "./loanProductCard";
import CustomInput from "./customInput";
import CustomButton from "./customButton";
import { useBookLoan, useLoanCalculator, useLoanProducts } from "../api/hooks/useLoan";
import LoanDetails from "./loanDetails";
import LoanInformation from "./loanInformation";
import { useNavigate } from "react-router-dom";
import LoanProductCard from "./loanProductCard";
import Loader from "./loader";
import EmptyListAlt from "./emptyListAlt";
import { extractErrors } from "../utils/utils";

// Steps
const steps = ["Select Loan", "Loan Calculator", "Loan Information"];

const LoanStepper = ({ }) => {
  const [loans, setLoans] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [startValidation, setStartValidation] = useState(false)
  const { data: loanData, isLoading, error } = useLoanProducts()
  const [bookLoanErrors, setBookLoanErrors] = useState(undefined);


  const [loanCalculatorForm, setLoanCalculatorForm] = useState({
    loan_product_id: "",
    loan_amount: "",
    desired_loan_disbursement_date: "",
    description: "",
    is_earning_monthly_salary: "",
    monthly_salary_amount: "",
    other_income_amount: "",
    monthly_expenses: "",
    marital_status: "",
    is_house_owner: "",
    house_address: "",
    has_dependents: "",
    no_of_dependents: "",
    is_planning_to_relocate: "",
    new_relocation_address: "",
    preferred_repayment_method: "",
    repayment_wallet_id: "",
    repayment_bank_id: "",
    repayment_bank_account_name: "",
    repayment_bank_account_number: "",
  })

  const bookLoanMutation = useBookLoan()

  const navigate = useNavigate();

  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (!loanData) return;

    setLoans(loanData.data);

  }, [loanData]);

  const validateForm = (formData) => {
    const errors = {};
    setStartValidation(true)

    if (!formData.loan_amount || formData.loan_amount <= 0) {
      errors.loan_amount = "Please enter a valid loan amount.";
    }
    if (!formData.desired_loan_disbursement_date) {
      errors.desired_loan_disbursement_date = "Please select a disbursement date.";
    }
    if (!formData.is_earning_monthly_salary) {
      errors.is_earning_monthly_salary = "Please tell us if you earn a monthly salary";
    }
    if (!formData.description || formData.description.trim() === "") {
      errors.description = "Purpose of loan is required.";
    }
    if (formData.is_earning_monthly_salary == "true" && !formData.monthly_salary_amount) {
      errors.monthly_salary_amount = "Monthly income is required.";
    }
    if (formData.preferred_repayment_method == "wallet" && !formData.repayment_wallet_id) {
      errors.repayment_wallet_id = "Repayment wallet is required";
    }
    if (!formData.is_house_owner) {
      errors.is_house_owner = "Please tell us if you're the house owner";
    }
    if (!formData.house_address) {
      errors.house_address = "House Address is required";
    }
    if (!formData.is_planning_to_relocate) {
      errors.is_planning_to_relocate = "Please tell us if you're planning to relocate";
    }
    if (!formData.has_dependents) {
      errors.has_dependents = "Please tell us if you have dependants";
    }
    if (!formData.marital_status) {
      errors.marital_status = "Marital Status is required.";
    }
    if (!formData.preferred_repayment_method) {
      errors.preferred_repayment_method = "Preferred repayment method is required.";
    }

    console.log(formData);

    console.log(errors, "Validation errors");


    return errors;
  };

  useEffect(() => {

    if (startValidation == true) {
      console.log("Validating things");

      const errors = validateForm(loanCalculatorForm);
      if (Object.keys(errors).length > 0) {
        setFormErrors(errors); // store errors in state
        return; // stop submission
      }
    }

  }, [startValidation, loanCalculatorForm])

  useEffect(() => {
    if (!bookLoanMutation.data) return;

    console.log(bookLoanMutation.data, "Book loan mutation");


    if (bookLoanMutation.data.status) {
      navigate("/loan-application-success");
    }

  }, [bookLoanMutation])

  useEffect(() => {
    if (!bookLoanMutation.error) return;

    console.log(bookLoanMutation.error, "Book loan mutation");

    if (!bookLoanMutation.error.response.data.status) {

      const theError = bookLoanMutation.error.response.data.errors == undefined ? bookLoanMutation.error.response.data.message : bookLoanMutation.error.response.data.errors;

      console.log(theError, "The main errosssssss");


      const allErrors = bookLoanMutation.error.response.data.errors == undefined ? theError : extractErrors(theError);

      console.log(allErrors, "Book loan erros");


      setBookLoanErrors(allErrors);

    }

  }, [bookLoanMutation.error])


  const loanCalMutation = useLoanCalculator();

  const handleChange = async (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    console.log(value);


    setLoanCalculatorForm({ ...loanCalculatorForm, [name]: value });
  };

  const handleSubmit = () => {
    const errors = validateForm(loanCalculatorForm);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors); // store errors in state
      return; // stop submission
    }

    const newLoanDetails = loanCalculatorForm;


    const newDetails = {
      ...loanCalculatorForm,
      is_earning_monthly_salary: loanCalculatorForm.is_earning_monthly_salary === "true",
      is_house_owner: loanCalculatorForm.is_house_owner === "true",
      has_dependents: loanCalculatorForm.has_dependents === "true",
      is_planning_to_relocate: loanCalculatorForm.is_planning_to_relocate === "true",
      no_of_dependents: loanCalculatorForm.no_of_dependents == "" ? 0 : loanCalculatorForm.no_of_dependents
    };

    if (loanCalculatorForm.is_planning_to_relocate == "false") {
      delete newDetails.new_relocation_address
    }

    if (loanCalculatorForm.is_earning_monthly_salary == "false") {
      delete newDetails.monthly_salary_amount
    }

    // @ts-ignore
    bookLoanMutation.mutate(newDetails);

    console.log("Submitting loan form:", newDetails);
  };


  const handleNext = () => {
    if (activeStep === 0 && !selectedLoan) return; // force loan selection first
    setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const handleLoanCalculator = () => {
    // @ts-ignore
    loanCalMutation.mutate({
      loan_product_id: selectedLoan.id,
      loan_amount: loanCalculatorForm.loan_amount,
      desired_loan_disbursement_date: loanCalculatorForm.desired_loan_disbursement_date
    });
  }

  return (
    <Box sx={{ width: "100%" }}>
      {/* Stepper */}
      {loans.length > 0 && <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>}

      {/* Step Content */}
      {loans.length > 0 && <Box sx={{ mt: 4 }}>
        {activeStep === 0 && (
          <div>
            {/* Available Loans Header */}
            <div>
              <div className="flex items-center justify-between">
                <h2 className="text-lg font-semibold">Available Loans</h2>
              </div>
              <p className="text-sm text-gray-400 mb-6">
                Select the best loan option for your needs
              </p>
            </div>

            {/* Loan Products */}
            {loans.length > 0 && (
              <div className="space-y-4">
                {loans.map((loan) => (
                  <LoanProductCard loan={loan} isSelected={selectedLoan == loan} onPress={() => {
                    setSelectedLoan(loan)
                    setLoanCalculatorForm({ ...loanCalculatorForm, loan_product_id: loan.id })
                  }} />
                ))}
              </div>
            )}

            {isLoading && <Loader />}
          </div>
        )}

        {activeStep === 1 && (
          <Box>
            <Typography variant="h6">Loan Details</Typography>
            <Typography variant="body2" color="text.secondary">
              You selected: <strong>{selectedLoan?.product_name}</strong>
            </Typography>
            <div className="mb-4" />

            <CustomInput inputName={"loan_amount"} value={loanCalculatorForm.loan_amount} label={"Loan Amount"} placeholder="Loan Amount" onChange={handleChange} />
            <CustomInput inputName={"desired_loan_disbursement_date"} value={loanCalculatorForm.desired_loan_disbursement_date} label={"Disbursement Date"} placeholder="Select Disbursement Date" inputType="date" onChange={handleChange} />

            <CustomButton label={"Calculate Loan"} isLoading={loanCalMutation.isPending} onPress={handleLoanCalculator} />


            {loanCalMutation.data && <LoanDetails loan={loanCalMutation.data.data} selectedLoan={selectedLoan} />}
          </Box>
        )}

        {activeStep === 2 && (
          <Box>
            <Typography variant="h6">Review & Submit</Typography>
            <LoanInformation formData={loanCalculatorForm} setFormData={setLoanCalculatorForm} formErrors={formErrors} networkError={bookLoanErrors} onBack={() => { }} />
          </Box>
        )}
      </Box>}

      {/* Navigation Buttons */}
      {loans.length > 0 && <Box sx={{ display: "flex", justifyContent: "space-between", mt: 4 }}>
        <Button
          disabled={activeStep === 0}
          onClick={handleBack}
          variant="outlined"
        >
          Back
        </Button>
        {activeStep < steps.length - 1 ? (
          <Button onClick={handleNext} variant="contained">
            Continue
          </Button>
        ) : (
          <CustomButton fullWidth={false} onPress={handleSubmit} isLoading={bookLoanMutation.isPending} label={"Book Loan"} />
        )}
      </Box>}


      {loans.length == 0 && !isLoading &&
        <EmptyListAlt title="No Loan Offers" message="We could not find a loan offer for you due to eligibility requirements. Please try again later after completing more transactions on your account." />}

    </Box>
  );
};

export default LoanStepper;
